$(document).ready(function() {
	$("#emailForPassword").validate();
	
	if((activated.length != 0 && JSON.parse(activated)) || 
			(alreadyActivated.length != 0 && JSON.parse(alreadyActivated))){
		 window.setTimeout(function(){
			   window.location.href= redirectUrl;
		    }, 2000);
	}
});
